import api from './api'

// Schools Service
export const schoolService = {
  getAll: async (params = {}) => {
    const response = await api.get('/schools', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await api.get(`/schools/${id}`)
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/schools', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/schools/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/schools/${id}`)
    return response.data
  },
  getBookNeeds: async (id) => {
    const response = await api.get(`/schools/${id}/book-needs`)
    return response.data
  },
  saveBookNeeds: async (id, items) => {
    const response = await api.post(`/schools/${id}/book-needs`, { items })
    return response.data
  }
}

// Vendors Service
export const vendorService = {
  getAll: async (params = {}) => {
    const response = await api.get('/vendors', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await api.get(`/vendors/${id}`)
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/vendors', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/vendors/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/vendors/${id}`)
    return response.data
  }
}

// Racks Service
export const rackService = {
  getAll: async (params = {}) => {
    const response = await api.get('/racks', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await api.get(`/racks/${id}`)
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/racks', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/racks/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/racks/${id}`)
    return response.data
  }
}

// Books Service
export const bookService = {
  getAll: async (params = {}) => {
    const response = await api.get('/books', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await api.get(`/books/${id}`)
    return response.data
  },
  getNextCetakKe: async (bookId) => {
    const response = await api.get(`/books/${bookId}/next-cetak`)
    return response.data
  },
  getMapelList: async () => {
    const response = await api.get('/books/mapel-list')
    return response.data
  },
  getSchoolNeeds: async (bookId) => {
    const response = await api.get(`/books/${bookId}/school-needs`)
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/books', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/books/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/books/${id}`)
    return response.data
  }
}

// Mapel Service
export const mapelService = {
  getAll: async (params = {}) => {
    const response = await api.get('/mapel', { params })
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/mapel', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/mapel/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/mapel/${id}`)
    return response.data
  }
}

// Users Service
export const userService = {
  getAll: async (params = {}) => {
    const response = await api.get('/users', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await api.get(`/users/${id}`)
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/users', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/users/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/users/${id}`)
    return response.data
  }
}

// Roles Service
export const roleService = {
  getAll: async (params = {}) => {
    const response = await api.get('/roles', { params })
    return response.data
  },
  getById: async (id) => {
    const response = await api.get(`/roles/${id}`)
    return response.data
  },
  create: async (data) => {
    const response = await api.post('/roles', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await api.put(`/roles/${id}`, data)
    return response.data
  },
  delete: async (id) => {
    const response = await api.delete(`/roles/${id}`)
    return response.data
  },
  getPermissions: async () => {
    const response = await api.get('/permissions')
    return response.data
  }
}

// Combined masterService for backward compatibility
export const masterService = {
  // Schools
  getSchools: schoolService.getAll,
  getSchoolById: schoolService.getById,
  createSchool: schoolService.create,
  updateSchool: schoolService.update,
  deleteSchool: schoolService.delete,
  getSchoolBookNeeds: schoolService.getBookNeeds,
  saveSchoolBookNeeds: schoolService.saveBookNeeds,
  // Vendors
  getVendors: vendorService.getAll,
  getVendorById: vendorService.getById,
  createVendor: vendorService.create,
  updateVendor: vendorService.update,
  deleteVendor: vendorService.delete,
  // Racks
  getRacks: rackService.getAll,
  getRackById: rackService.getById,
  createRack: rackService.create,
  updateRack: rackService.update,
  deleteRack: rackService.delete,
  // Books
  getBooks: bookService.getAll,
  getBookById: bookService.getById,
  getNextCetakKe: bookService.getNextCetakKe,
  createBook: bookService.create,
  updateBook: bookService.update,
  deleteBook: bookService.delete,
  // Mapel
  getMapel: mapelService.getAll,
  createMapel: mapelService.create,
  updateMapel: mapelService.update,
  deleteMapel: mapelService.delete,
}

export default {
  school: schoolService,
  vendor: vendorService,
  rack: rackService,
  book: bookService,
  mapel: mapelService,
  user: userService,
  role: roleService
}
